export { default as getDarkColor } from './utils/getDarkColor';
